import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

interface NotAllowedRoute {
  label: string;
  route: string;
}

@Component({
  selector: 'app-not-allowed',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './not-allowed.component.html',
  styleUrl: './not-allowed.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotAllowedComponent {
  readonly routes: NotAllowedRoute[] = [
    { label: 'Dashboard', route: '/dashboard' },
    { label: 'Inbox', route: '/inbox' },
    { label: 'Wallet', route: '/wallet-v2' },
    { label: 'My account', route: '/my-account' },
  ];
}

